<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input style="width: 150px; margin-right: 10px" placeholder="请输入关键字" v-model="params.keyword"
                size="small"></el-input>
              <el-button @click="changeSearch" icon="el-icon-search" type="warning" size="small">搜索
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="门店" :label-width="'40px'">
              <el-select v-model="params.shopId" placeholder="请选择" clearable @change="changeSearch" size="small"
                style="width: 100px">
                <el-option v-for="item in this.$store.state.userInfo.shops" :key="item.shop_id" :label="item.shop_name"
                  :value="item.shop_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="是否有库存" :label-width="'90px'">
              <el-select style="width: 100px" v-model="params.stockStatus" @change="changeSearch">
                <el-option popper-class="select" v-for="item in [
            { label: '不限', value: -1 },
            { label: '无库存', value: 0 },
            { label: '有库存', value: 1 },
          ]" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="适用宠物" :label-width="'80px'">
              <el-select style="width: 100px" v-model="params.applyType" @change="changeSearch">
                <el-option popper-class="select" v-for="item in [
            { label: '全部', value: -1 },
            { label: '通用', value: 0 },
            { label: '猫', value: 1 },
            { label: '狗', value: 2 },
          ]" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
						<el-form-item label="商品状态" :label-width="'80px'">
							<el-radio-group v-model="search.status" @change="changeSearch">
								<el-radio :label="''">全部</el-radio>
								<el-radio :label="'1'">上架</el-radio>
								<el-radio :label="'0'">下架</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col> -->
          <!-- <el-col :span="2">
						<resetBtn @reset="reset"></resetBtn>
					</el-col> -->
          <!-- <div class="btns">
            <el-form-item>
              <el-button
                style="margin-right: 10px"
                type="warning"
                size="small"
                @click="derive"
                >导出表格
              </el-button>
              <el-cascader
                v-if="isShow"
                :options="options"
                clearable
                :props="{ expandTrigger: 'hover' }"
                :show-all-levels="false"
                v-model="value"
                @change="handleChange"
                style="width: 120px"
              >
              </el-cascader>
            </el-form-item>
          </div> -->
        </el-row>
      </el-form>
    </div>
    <div class="tabLine">
      <div class="tabItem" :class="[tabs == 1 ? 'active' : '']" @click="handleTabClick(1)">
        商品
      </div>
      <div class="tabItem" :class="[tabs == 2 ? 'active' : '']" @click="handleTabClick(2)">
        药品
      </div>
      <div class="tabItem" :class="[tabs == 3 ? 'active' : '']" @click="handleTabClick(3)">
        耗材
      </div>
    </div>

    <div class="pageConBox">

      <div class="navBox">
        <el-tree :data="categoryList" :highlight-current="true" node-key="id" default-expand-all
          :expand-on-click-node="false" @node-click="handleNodeClick">
        </el-tree>
      </div>
      <div class="tableBox" ref="tableBox">
        <el-table v-if="tabs == 1" :data="goodsData" style="width: 100%" ref="table1" row-class-name="row-expand-cove">
          <el-table-column prop="title" label="名称" width="180" :key="Math.random()">
            <template slot-scope="scope">
              <div v-if="$public.isNull(scope.row.cover)">
                {{ scope.row.title }}
              </div>
              <el-tooltip v-else placement="top" effect="light">
                <div slot="content">
                  <img :src="scope.row.cover" style="width: 300px" />
                </div>
                <div>{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="适用宠物" width="70">
            <template slot-scope="scope">
              <span>{{ scope.row.apply_type.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="80">
            <template slot-scope="scope">
              {{ scope.row.brand_name }}
            </template>
          </el-table-column>
          <el-table-column label="分类" width="80">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column label="规格/条码/包装/售价/库存">
            <template slot-scope="scope">
              <div>
                <div style="display: flex; padding: 5px" v-for="(item, index) in scope.row.skus_list" :key="index">
                  <div class="column" style="width: 300px; margin-right: 50px">
                    <span>
                      <span v-if="$public.isNull(item.image)">{{
            item.skus_name
          }}</span>
                      <el-tooltip v-else placement="top" effect="light">
                        <div slot="content">
                          <img :src="item.image[0]" style="width: 300px" />
                        </div>
                        <span>{{ item.skus_name }}</span>
                      </el-tooltip>
                      <el-button type="text" v-if="$buttonAuthority('cangku2-kucun-educe')" icon="el-icon-edit" size="max"
                        @click="editStock(item,scope.row)"></el-button>
                    </span>
                    <span style="color: black;font-size: 17px;margin: 0 20px;">{{
            item.barcode ? item.barcode : ''
          }}</span>
                  </div>
                  <div class="column" style="width: 150px">
                    <div style="margin: 1px" v-for="(item1, index1) in item.sale_way" :key="index1">
                      {{ item1.packing_way_name }}
                      <span style="margin: 0 10px">￥{{ item1.pprice }}</span>
                    </div>
                  </div>
                  <div class="column">
                    <div style="margin: 1px" v-for="(item1, index1) in item.stock" :key="index1">
                      <span style="margin: 0 30px">{{ item1.shopName }}:{{ item1.stock }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="expand" v-loading="loadtable" width="1">
            <template slot-scope="scope">
              <div v-if="loadtable" style="text-align: center">
                <i class="el-icon-loading" style="font-size: 30px"></i>
              </div>
              <div v-else>
                <div>{{ scope.row.title }}({{ customCodeData.skuValue }})</div>
                <el-form label-position="left" class="demo-table-expand">
                  <el-form-item>
                    <el-tag style="margin: 5px" v-for="item in customCodeData.customCode" :key="item.customCode">
                      {{ item.customCode }}
                      <span style="margin-left: 10px; color: #8e71e4">
                        总量
                        <span style="color: #8e71e4">{{ item.totaTimes }}</span>
                      </span>
                      <span style="margin-left: 10px; color: #fc6f6f">
                        已使用量
                        <span style="color: #fc6f6f">{{ item.useTimes }}</span>
                      </span>
                      <span style="margin-left: 10px; color: #67c23a">
                        剩余量
                        <span style="color: #67c23a">{{
            item.totaTimes - item.useTimes
          }}</span>
                      </span>
                    </el-tag>
                  </el-form-item>
                </el-form>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="tabs == 2">
          <el-table :data="medicalData" style="width: 100%" ref="table2" row-class-name="row-expand-cove">
            <el-table-column prop="title" label="项目名称" :key="Math.random()">
              <template slot-scope="scope">
                <div v-if="$public.isNull(scope.row.cover)">
                  {{ scope.row.title }}
                </div>
                <el-tooltip v-else placement="top" effect="light">
                  <div slot="content">
                    <img :src="scope.row.cover" style="width: 300px" />
                  </div>
                  <div>{{ scope.row.title }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="适用宠物" :key="Math.random()">
              <template slot-scope="scope">
                <span>{{ scope.row.apply_type.title }}</span>
              </template>
            </el-table-column>
            <el-table-column label="品牌" :key="Math.random()">
              <template slot-scope="scope">
                <span>{{ scope.row.brand_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="规格" :key="Math.random()">
              <template slot-scope="scope">
                <span>{{ scope.row.old_packinfo_info.sku_value }}</span>
              </template>
            </el-table-column>
            <el-table-column label="分类" :key="Math.random()">
              <template slot-scope="scope">
                <span>{{ scope.row.category_info.name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="价格" prop="pprice" :key="Math.random()">
              <template slot-scope="scope">
                <span>{{ scope.row.pprice }}</span>
              </template>
            </el-table-column>

            <el-table-column label="库存" width="400px">
              <template slot-scope="scope">
                <div style="margin: 1px" v-for="(stockitem, key) in scope.row.stock" :key="key">
                  <span style="margin: 0 30px">{{ stockitem.shopName }}:{{ stockitem.stock }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column type="expand" v-loading="loadtable" width="1">
              <template slot-scope="scope">
                <div v-if="loadtable" style="text-align: center">
                  <i class="el-icon-loading" style="font-size: 30px"></i>
                </div>
                <div v-else>
                  <div>
                    {{ scope.row.title }}({{ customCodeData.skuValue }})
                  </div>
                  <el-form label-position="left" class="demo-table-expand">
                    <el-form-item>
                      <el-tag style="margin: 5px" v-for="item in customCodeData.customCode" :key="item.customCode">
                        {{ item.customCode }}
                        <span style="margin-left: 10px; color: #8e71e4">
                          总量
                          <span style="color: #8e71e4">{{
            item.totaTimes
          }}</span>
                        </span>
                        <span style="margin-left: 10px; color: #fc6f6f">
                          已使用量
                          <span style="color: #fc6f6f">{{
              item.useTimes
            }}</span>
                        </span>
                        <span style="margin-left: 10px; color: #67c23a">
                          剩余量
                          <span style="color: #67c23a">{{
              item.totaTimes - item.useTimes
            }}</span>
                        </span>
                      </el-tag>
                    </el-form-item>
                  </el-form>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <el-table v-if="tabs == 3" :data="consumablesData" style="width: 100%" ref="table3"
          row-class-name="row-expand-cove">
          <el-table-column prop="title" label="名称" :key="Math.random()" width="180px">
            <template slot-scope="scope">
              <div v-if="$public.isNull(scope.row.cover)">
                {{ scope.row.title }}
              </div>
              <el-tooltip v-else placement="top" effect="light">
                <div slot="content">
                  <img :src="scope.row.cover" style="width: 300px" />
                </div>
                <div>{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="分类" :key="Math.random()" width="80px">
            <template slot-scope="scope">
              <span>{{ scope.row.category_info.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否限制" :key="Math.random()" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.count_limit == 0">不限制</span>
              <span v-else>限制</span>
            </template>
          </el-table-column>
          <el-table-column label="包装单位" prop="packing_unit">
          </el-table-column>
          <el-table-column label="使用单位" prop="use_unit" width="80px">
          </el-table-column>
          <el-table-column label="建议使用次数" prop="use_times" width="100px">
          </el-table-column>
          <el-table-column label="库存" :key="3" width="300px">
            <template slot-scope="scope">
              <div style="margin: 1px" v-for="(stockitem, key) in scope.row.stock" :key="key">
                <span style="margin: 0 30px">{{ stockitem.shopName }}:{{ stockitem.stock }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="expand" v-loading="loadtable" width="1">
            <template slot-scope="scope">
              <div v-if="loadtable" style="text-align: center">
                <i class="el-icon-loading" style="font-size: 30px"></i>
              </div>
              <div v-else>
                <div>{{ scope.row.title }}({{ customCodeData.skuValue }})</div>
                <el-form label-position="left" class="demo-table-expand">
                  <el-form-item>
                    <el-tag style="margin: 5px" v-for="item in customCodeData.customCode" :key="item.customCode">
                      {{ item.customCode }}
                      <span style="margin-left: 10px; color: #8e71e4">
                        总量
                        <span style="color: #8e71e4">{{ item.totaTimes }}</span>
                      </span>
                      <span style="margin-left: 10px; color: #fc6f6f">
                        已使用量
                        <span style="color: #fc6f6f">{{ item.useTimes }}</span>
                      </span>
                      <span style="margin-left: 10px; color: #67c23a">
                        剩余量
                        <span style="color: #67c23a">{{
            item.totaTimes - item.useTimes
          }}</span>
                      </span>
                    </el-tag>
                  </el-form-item>
                </el-form>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <page style="padding: 10px 10px" :page="params.pageIndex" :total="total" @change="changePage"></page>
      </div>
    </div>
    <div v-if="dialog_goodsRecord_state">
      <dialogGoodsRecord :goodsMsg="curGoodsMsg" @submit="submit_dialogGoodsRecord"></dialogGoodsRecord>
    </div>
    <el-dialog
      title="库存设置"
      :visible.sync="dialogProductType"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="stocklist" label-width="80px">
        <el-form-item label="门店">
          <div>{{ $public.getShopNameById(curShopId) }}</div>
        </el-form-item>
        <el-form-item label="规格">
          <div>{{ stocklist.skus_name }}</div>
        </el-form-item>
        <el-form-item label="库存数量">
          <el-input-number v-model="num" controls-position="right" :min="0" size="small" @change="handleChange(num)"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="warning" @click="onSubmitProductType"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import dialogGoodsRecord from "../../../components/dialog_goodsRecord.vue";
import page from "../../../components/page.vue";
// import resetBtn from "../../../components/resetBtn.vue"
// this.$store.getters.curShopInfo.shop_idstock
import {
  getProductTypeList,
  getProductMedicalList,
  getProductGoodsList,
  getConsumablesList,
} from "../../../api/productApi.js";
export default {
  components: {
    dialogGoodsRecord,
    page,
    // resetBtn
  },
  data() {
    return {
      value: [],
      dialogProductType: false,
      productId:'',
      stocklist:{},
      options: [
        {
          value: "a",
          label: "导出",
          children: [
            {
              value: "0",
              label: "导出商品",
            },
            {
              value: "1",
              label: "导出药品",
            },
            {
              value: "7",
              label: "导出耗材",
            },
          ],
        },
        {
          value: "b",
          label: "导出明细",
          children: [
            {
              value: "0",
              label: "导出商品明细",
            },
            {
              value: "1",
              label: "导出药品明细",
            },
            {
              value: "7",
              label: "导出耗材明细",
            },
          ],
        },
      ],
      // options: [
      //   {
      //     value: "0",
      //     label: "商品",
      //   },
      //   {
      //     value: "1",
      //     label: "药品",
      //   },
      //   {
      //     value: "7",
      //     label: "耗材",
      //   },
      // ],
      goodsType1: "",
      goodsType2: "",
      tabs: 1,
      activeName1: "",
      activeName2: "",
      categoryList: [],

      params: {
        pageSize: 10,
        pageIndex: 1,
        categoryId: "",
        keyword: "",
        shopId: "",
        stockStatus: -1, // -1 不限 0无库存 1有库存
        applyType: -1, //  -1全部 0通用 1猫 2狗
      },
      //条码显示格式
      customCodeData: {
        skuValue: "",
        shopName: "",
        customCode: [],
      },
      loadtable: false,
      // 查看弹出
      dialog_goodsRecord_state: false,
      curGoodsMsg: {},
      // 眼睛展开
      curSkuItem: {},
      consumablesData: [],
      goodsData: [],
      medicalData: [],
      total: 0,
      num:0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.getCategoryList(this.tabs);
    if (this.tabs == 1) {
      this.getProductGoodsList();
    } else if (this.tabs == 2) {
      this.getProductMedicalList();
    } else {
      this.getConsumablesList();
    }
    // this.getTableData();
  },
  methods: {
    handleChange(num){
      console.log(num,'num');
      this.num=num

    },
    onSubmitProductType() {
      if (this.num==0) {
        this.$message({
          type: "warning",
          message: "数量不能为0",
        });
      } else {
         let storcks=[]
         let item={
          productType:0,
          productId:this.productId,
          skuId:this.stocklist._id,
          unitId:this.stocklist.sale_way[0].packing_way_id,
          count:this.num
         }
         storcks.push(item)
        let params={
         shopId:this.curShopId,
         inUserId:this.userInfo.uid,
         inUserName:this.userInfo.uName,
         items:storcks
        }
        this.$http.post(
          process.env.VUE_APP_Url66 + "api/in/shop/init/stock",params
        ).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            this.dialogProductType = false;
            this.getProductGoodsList();
          }
        });
      }
    },
    see(row) {
      this.curGoodsMsg = row;
      this.dialog_goodsRecord_state = true;
    },
    // 编辑库存
    editStock(item,row){
      this.stocklist=item
      this.productId=row.goodsId
      this.dialogProductType=true
      console.log(item,row,'kucun');

    },
    submit_dialogGoodsRecord() {
      this.dialog_goodsRecord_state = false;
    },
    reset() {
      this.search.keyword = "";
      this.search.goodsTypeId = "";
      this.search.status = "";
      this.params.pageIndex = 1;
      this.getTableData();
    },
    changeSearch() {
      this.params.pageIndex = 1;
      if (this.tabs == 1) {
        this.getProductGoodsList();
      } else if (this.tabs == 2) {
        this.getProductMedicalList();
      } else {
        this.getConsumablesList();
      }
    },
    // 改变分页
    changePage(num) {
      this.params.pageIndex = num;
      if (this.tabs == 1) {
        this.getProductGoodsList();
      } else if (this.tabs == 2) {
        this.getProductMedicalList();
      } else {
        this.getConsumablesList();
      }
    },
    getProductMedicalList() {
      getProductMedicalList(this.params).then((res) => {
        if (res.code == 0) {
          this.medicalData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    getProductGoodsList() {
      getProductGoodsList(this.params).then((res) => {
        if (res.code == 0) {
          this.goodsData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    getConsumablesList() {
      getConsumablesList(this.params).then((res) => {
        if (res.code == 0) {
          this.consumablesData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    // 获取商品类别列表
    getCategoryList(tab) {
      let category;
      if (tab == 1) {
        category = "商品";
      } else if (tab == 2) {
        category = "医疗";
      } else {
        category = "耗材";
      }
      getProductTypeList({
        category: category,
      }).then((res) => {
        if (res.code == 0) {
          this.categoryList = res.data[0].children;
          console.log(res.data[0].children, '123456');
          this.recursion(this.categoryList);
        }
      });
    },
    // 递归
    recursion(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].children == null || arr[i].children.length == 0) {
          arr[i].children = null;
        } else {
          this.recursion(arr[i].children);
        }
      }
    },
    handleNodeClick(data) {
      this.params.pageIndex = 1;
      this.params.categoryId = data.id;
      if (this.tabs == 1) {
        this.getProductGoodsList();
      } else if (this.tabs == 2) {
        this.getProductMedicalList();
      } else {
        this.getConsumablesList();
      }
      this.$refs.tableBox.scrollTop = 0;
    },
    handleTabClick(tab) {
      this.tabs = tab;
      this.params.categoryId = "";
      this.params.pageIndex = 1;

      this.getCategoryList(tab);

      if (tab == 1) {
        this.getProductGoodsList();
      } else if (tab == 2) {
        this.getProductMedicalList();
      } else {
        this.getConsumablesList();
      }
    },

  },
};
</script>
<style>
::v-deep .el-cascader__dropdown {
  height: 80px;
}
</style>
<style lang="scss" scoped="scoped">
.page {
  height: 100%;

  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .tabLine {
    margin-top: 12px;
    display: flex;

    .tabItem {
      padding: 0 16px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;

      &.active {
        color: $mainColor;
      }
    }
  }

  .pageConBox {
    display: flex;
    border-top: 1px solid #f2f2f2;
    height: calc(100% - 115px);

    .navBox {
      width: 160px;
      padding: 10px;
      height: 100%;
      border-radius: 6px;
      background-color: #fff;
      border-right: 13px solid #f5f5f5;
      overflow: auto;
      box-sizing: border-box;

      .navItem {
        line-height: 40px;
        padding-left: 20px;
        cursor: pointer;

        .active {
          color: #1890ff;
        }
      }

      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }

      ::v-deep.el-collapse-item__wrap {
        border: 0;
      }

      ::v-deep.el-collapse-item__header {
        border: 0;
      }

      ::v-deep.el-collapse {
        border: 0;
      }

      ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: $mainColor;
        border-radius: 4px;
        color: #fff;
      }
    }
  }

  .tableBox {
    width: calc(100% - 160px);
    height: 100%;
    overflow: auto;
  }

  .el-table__expand-icon {
    height: 0;
  }
}

.btns {
  display: flex;
  justify-content: space-between;

  .btn {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
